import { axiosApiCall } from "./index";
import {
    login,
    forgotPassword,
    GetDiplomas,
    GetStates,
    TherapistSignup,
    PatientSignup,
    GetDashboardCountsApi,
    CheckLoginApi,
    GetTherapistProfileApi,
    GetMyPatientsApi,
    GetMyAppoinmentsApi,
    SavePatientRefuseAssessmentApi,
    UpdateAppoinmentStatusApi,
    GetTherapistTimeSlotsApi,
    AdminSendEmailApi,
    SaveNotificationApi,
    UploadDocumentApi,
    GetPatientAssessmentsApi,
    GetPatientNoteApi,
    SavePetientNoteApi,
    GetVideosApi,
    SaveShareVideosApi,
    PatientSendEmailApi,
    SaveAssessmentNotesApi,
    PatientGetProfileApi,
    TP_GetPatientMedicalHistoryApi,
    TherapistGetSchedule,
    TherapistGetAppoinment,
    TherapistGetTimeInterval,
    TherapistGetPopupdata,
    TherapistSaveScheduleTime,
    TherapistSaveAppoinment,
    PatientSaveAppoinment,
    TherapistPatientCancelRefuseAssessment,
    TherapistRevertVPTCancelAssessment,
    PatientPrescriptionGet,
    TherapistPatientDischargeManage,
    GetTimeZone,
    TherapistSaveTherapistProfile,
    TherapistUpload,
    AdminUpload,
    TherapistSaveSchedule,
    AdminGetPatientHealthDetails,
    TherapistGetPatientOtherAssessment,
    TherapistGetPreviousAssessment,
    TherapistSavePatientOtherAssessment,
    TherapistGetAssessmentTemplates,
    TherapistSaveAssessmentTemplate,
    TherapistGetPatientAssessment,
    TherapistGetPatientRefuseAssessment,
    TherapistGetPatientCervicalAssessment2,
    TherapistGetPatientCervicalAssessment3,
    TherapistGetPatientLowerAssessment3,
    TherapistGetPatientLowerAssessment2,
    TherapistGetPatientThoracicAssessment2,
    TherapistGetPatientThoracicAssessment3,
    TherapistGetPatientUpperAssessment2,
    TherapistGetPatientUpperAssessment3,
    PatientGetMedicalHistories,
    PatientGetPatientMedicalHistory,
    TherapistGetPatientLumbarAssessment2,
    TherapistGetPatientLumbarAssessment3,
    AdminManageFile,
    AdminManagePatientNew,
    AdminGetAppoinmentsStatus,
    AdminGetQualityAnalysisReport,
    AdminGetCAPrisonReport,
    AdminGetDmeSurgicalAppoinments,
    AdminGetUserDetails,
    AdminGetAllTherapists,
    AdminGetCompanies,
    AdminGetPrisonDiagnosisCodes,
    AdminGetPrisonSites,
    AdminSearchPatient,
    AdminSaveInboxMessage,
    GetAssesmentPdfApi,
    TherapistGetPatientVestibularAssessment2,
    TherapistGetPatientVestibularAssessment3,
    TherapistGetPatientReAssessment,
    TherapistGetPatientReAssessment2,
    PatientGetAppoinments,
    TherapistGetSharedVideos,
    PatientSavePatientMedicalHistory,
    PatientGetPatientAssessmentZoomDetailWeb,
    PatientGetTherapists,
    GetCompanies,
    PatientGetCompaniesforPatient,
    PatientSaveAppoinmentNew,
    PatientRequestForAppoinment,
    AdminRegisterNurse,
    AdminGetDashBoardData,
    AdminEnableDisableUser,
    AdminOverrideUserNPI,
    AdminGetMyPatient,
    AdminGetMyPayments,
    AdminGetMarketingData,
    AdminAppRejUser,
    AdminGetAppointments,
    AdminGetAppointmentPays,
    AdminUpdateAppointmentPay,
    AdminGetAccountReceived,
    AdminGetDischargeReport,
    AdminGetFirstAppoinments,
    AdminGetRequestsForAppointment,
    AdminGetPatientDischarge,
    AdminDownloadPatientDischarge,
    AdminDownloadPatientRefusal,
    AdminGetPatientRefusal,
    AdminGetUpdateUserFees,
    AdminUpdateRequestStatus,
    AdminGetAccountReceivable,
    AdminGenerateInvoice,
    AdminGetTherapistAppoinments,
    AdminGetAllTherapist,
    AdminUpdateAccountReceivable,
    AdminGetSelfPayAppointments,
    StripeCheckoutCreateIntent,
    StripeCheckoutBookSelfPayAppointment,
    AdminUpdateTherapistFees,
    SetPassword,
    UpdateRstPasswordink,
    AdminSubmitClaimForm
} from "./apiurl";
const apiBaseUrl = "https://web.vptsapp.com/api/api/";
// const apiVptsBaseUrl = "http://localhost:5001/api/";
const apiVptsBaseUrl = apiBaseUrl;

export const loginApi = async (payload: any) => {
    const response = await axiosApiCall.post(`${apiVptsBaseUrl}${login}`, payload);
    return response;
}

export const forgotPasswordApi = async (payload: any) => {
    const response = await axiosApiCall.post(`${apiVptsBaseUrl}${forgotPassword}`, payload);
    return response;
}

export const getDiplomasApi = async () => {
    const response = await axiosApiCall.get(`${apiVptsBaseUrl}${GetDiplomas}`);
    return response;
}

export const getStatesApi = async () => {
    const response = await axiosApiCall.get(`${apiVptsBaseUrl}${GetStates}`);
    return response;
}

export const getTimeZoneApi = async () => {
    const response = await axiosApiCall.get(`${apiVptsBaseUrl}${GetTimeZone}`);
    return response;
}

export const signUpApi = async (payload: any) => {
    const response = await axiosApiCall.post(`${apiVptsBaseUrl}${TherapistSignup}`, payload);
    return response;
}

export const patientSignUpApi = async (payload: any) => {
    const response = await axiosApiCall.post(`${apiVptsBaseUrl}${PatientSignup}`, payload);
    return response;
}

export const GetDashboardCounts = async (payload: any) => {
    const response = await axiosApiCall.get(`${apiVptsBaseUrl}${GetDashboardCountsApi}${payload}`);
    return response;
}

export const CheckLogin = async () => {
    const response = await axiosApiCall.get(`${apiVptsBaseUrl}${CheckLoginApi}`);
    return response;
}

export const GetTherapistProfile = async (UserGuid: string) => {
    const response = await axiosApiCall.get(`${apiVptsBaseUrl}${GetTherapistProfileApi}?UserGuid=${UserGuid}`);
    return response;
}

export const GetMyPatients = async (payload: any) => {
    let url = `${apiVptsBaseUrl}${GetMyPatientsApi}`;
    url = queryParamsToUrl(url, payload);
    const response = await axiosApiCall.get(url);
    return response;
}

const queryParamsToUrl = (url: string, queryParams: any) => {
    if (queryParams && queryParams?.length > 0) {
        url = queryParams?.reduce((res: any, item: any, index: number) => {
            return (res += `${index === 0 ? "?" : "&"}${item.key}=${item.value}`)
        }, url)
    }
    return url;
}

export const GetMyAppoinments = async (payload: any) => {
    let url = `${apiVptsBaseUrl}${GetMyAppoinmentsApi}`;
    url = queryParamsToUrl(url, payload);
    const response = await axiosApiCall.get(url);
    return response;
}

export const SavePatientRefuseAssessment = async (payload: any) => {
    const response = await axiosApiCall.post(`${apiVptsBaseUrl}${SavePatientRefuseAssessmentApi}`, payload);
    return response;
}

export const UpdateAppoinmentStatus = async (payload: any) => {
    const response = await axiosApiCall.post(`${apiVptsBaseUrl}${UpdateAppoinmentStatusApi}`, payload);
    return response;
}

export const GetTherapistTimeSlots = async (payload: any) => {
    let url = `${apiVptsBaseUrl}${GetTherapistTimeSlotsApi}`;
    url = queryParamsToUrl(url, payload);
    const response = await axiosApiCall.get(url);
    return response;
}

export const AdminSendEmail = async (payload: any) => {
    const response = await axiosApiCall.post(`${apiVptsBaseUrl}${AdminSendEmailApi}`, payload);
    return response;
}

export const SaveNotification = async (payload: any) => {
    const response = await axiosApiCall.post(`${apiVptsBaseUrl}${SaveNotificationApi}`, payload);
    return response;
}

export const UploadDocument = async (payload: any) => {
    const response = await axiosApiCall.post(`${apiVptsBaseUrl}${UploadDocumentApi}`, payload, { isUpload: true } as any);
    return response;
}

export const GetPatientAssessments = async (payload: any) => {
    let url = `${apiVptsBaseUrl}${GetPatientAssessmentsApi}`;
    url = queryParamsToUrl(url, payload);
    const response = await axiosApiCall.get(url);
    return response;
}

export const GetPatientNotes = async (payload: any) => {
    let url = `${apiVptsBaseUrl}${GetPatientNoteApi}`;
    url = queryParamsToUrl(url, payload);
    const response = await axiosApiCall.get(url);
    return response;
}

export const SavePetientNote = async (payload: any) => {
    const response = await axiosApiCall.post(`${apiVptsBaseUrl}${SavePetientNoteApi}`, payload);
    return response;
}

export const GetVideos = async (payload: any) => {
    let url = `${apiVptsBaseUrl}${GetVideosApi}`;
    url = queryParamsToUrl(url, payload);
    const response = await axiosApiCall.get(url);
    return response;
}

export const SaveShareVideos = async (payload: any) => {
    const response = await axiosApiCall.post(`${apiVptsBaseUrl}${SaveShareVideosApi}`, payload);
    return response;
}

export const PatientSendEmail = async (payload: any) => {
    const response = await axiosApiCall.post(`${apiVptsBaseUrl}${PatientSendEmailApi}`, payload);
    return response;
}

export const SaveAssessmentNotes = async (payload: any) => {
    const response = await axiosApiCall.post(`${apiVptsBaseUrl}${SaveAssessmentNotesApi}`, payload);
    return response;
}

export const PatientGetProfile = async (payload: any) => {
    let url = `${apiVptsBaseUrl}${PatientGetProfileApi}`;
    url = queryParamsToUrl(url, payload);
    const response = await axiosApiCall.get(url);
    return response;
}

export const getPatientMedicalHistory = async (payload: any) => {
    let url = `${apiVptsBaseUrl}${TP_GetPatientMedicalHistoryApi}`;
    url = queryParamsToUrl(url, payload);
    const response = await axiosApiCall.get(url);
    return response;
}

export const getTherapistGetSchedule = async (payload: any) => {
    let url = `${apiVptsBaseUrl}${TherapistGetSchedule}`;
    url = queryParamsToUrl(url, payload);
    const response = await axiosApiCall.get(url);
    return response;
}

export const getTherapistAppoinment = async (payload: any) => {
    let url = `${apiVptsBaseUrl}${TherapistGetAppoinment}`;
    url = queryParamsToUrl(url, payload);
    const response = await axiosApiCall.get(url);
    return response;
}

export const getTherapistGetTimeInterval = async (payload: any) => {
    let url = `${apiVptsBaseUrl}${TherapistGetTimeInterval}`;
    url = queryParamsToUrl(url, payload);
    const response = await axiosApiCall.get(url);
    return response;
}

export const getTherapistGetPopupdata = async (payload: any) => {
    let url = `${apiVptsBaseUrl}${TherapistGetPopupdata}`;
    url = queryParamsToUrl(url, payload);
    const response = await axiosApiCall.get(url);
    return response;
}

export const therapistSaveScheduleTime = async (payload: any) => {
    const response = await axiosApiCall.post(`${apiVptsBaseUrl}${TherapistSaveScheduleTime}`, payload);
    return response;
}

export const patientSaveAppoinment = async (payload: any) => {
    const response = await axiosApiCall.post(`${apiVptsBaseUrl}${PatientSaveAppoinment}`, payload);
    return response;
}

export const therapistSaveAppoinment = async (payload: any) => {
    const response = await axiosApiCall.post(`${apiVptsBaseUrl}${TherapistSaveAppoinment}`, payload);
    return response;
}

export const patientCancelRefuseAssessment = async (payload: any) => {
    const response = await axiosApiCall.post(`${apiVptsBaseUrl}${TherapistPatientCancelRefuseAssessment}`, payload);
    return response;
}

export const therapistRevertVPTCancelAssessment = async (payload: any) => {
    const response = await axiosApiCall.post(`${apiVptsBaseUrl}${TherapistRevertVPTCancelAssessment}`, payload);
    return response;
}

export const GetPatientPrescriptionData = async (payload: any) => {
    let url = `${apiVptsBaseUrl}${PatientPrescriptionGet}`;
    url = queryParamsToUrl(url, payload);
    const response = await axiosApiCall.get(url);
    return response;
}

export const patientDischargeManage = async (payload: any) => {
    const response = await axiosApiCall.post(`${apiVptsBaseUrl}${TherapistPatientDischargeManage}`, payload);
    return response;
}

export const SaveTherapistProfile = async (payload: any) => {
    const response = await axiosApiCall.post(`${apiVptsBaseUrl}${TherapistSaveTherapistProfile}`, payload);
    return response;
}

export const therapistSaveScheduleOnUncheck = async (payload: any) => {
    const response = await axiosApiCall.post(`${apiVptsBaseUrl}${TherapistSaveSchedule}`, payload);
    return response;
}

export const UploadPhoto = async (payload: any) => {
    const settings = {
        method: "POST",
        body: payload,
        credentials: "include" as RequestCredentials,
        headers: {
            'Accept': 'application/json, text/plain, */*',
            'ContentType': 'multipart/form-data',
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Headers": "*",
        }
    }
    return fetch(`${apiVptsBaseUrl}${TherapistUpload}`, settings)
        .then((response) => {
            return response.json()
        })
        .then(responseJson => {
            return responseJson;
        })
}

export const getPatientHealthDetails = async (payload: any) => {
    let url = `${apiVptsBaseUrl}${AdminGetPatientHealthDetails}`;
    url = queryParamsToUrl(url, payload);
    const response = await axiosApiCall.get(url);
    return response;
}

export const GetPatientOtherAssessment = async (payload: any) => {
    let url = `${apiVptsBaseUrl}${TherapistGetPatientOtherAssessment}`;
    url = queryParamsToUrl(url, payload);
    const response = await axiosApiCall.get(url);
    return response;
}

export const GetPreviousAssessment = async (payload: any) => {
    let url = `${apiVptsBaseUrl}${TherapistGetPreviousAssessment}`;
    url = queryParamsToUrl(url, payload);
    const response = await axiosApiCall.get(url);
    return response;
}

export const SavePatientOtherAssessment = async (payload: any) => {
    const response = await axiosApiCall.post(`${apiVptsBaseUrl}${TherapistSavePatientOtherAssessment}`, payload);
    return response;
}

export const GetAssessmentTemplates = async (payload: any) => {
    let url = `${apiVptsBaseUrl}${TherapistGetAssessmentTemplates}`;
    url = queryParamsToUrl(url, payload);
    const response = await axiosApiCall.get(url);
    return response;
}

export const SaveAssessmentTemplate = async (payload: any) => {
    const response = await axiosApiCall.post(`${apiVptsBaseUrl}${TherapistSaveAssessmentTemplate}`, payload);
    return response;
}

export const getPatientAssessment = async (payload: any) => {
    let url = `${apiVptsBaseUrl}${TherapistGetPatientAssessment}`;
    url = queryParamsToUrl(url, payload);
    const response = await axiosApiCall.get(url);
    return response;
}

export const getPatientRefuseAssessment = async (payload: any) => {
    let url = `${apiVptsBaseUrl}${TherapistGetPatientRefuseAssessment}`;
    url = queryParamsToUrl(url, payload);
    const response = await axiosApiCall.get(url);
    return response;
}

export const getPatientCervicalAssessment2 = async (payload: any) => {
    let url = `${apiVptsBaseUrl}${TherapistGetPatientCervicalAssessment2}`;
    url = queryParamsToUrl(url, payload);
    const response = await axiosApiCall.get(url);
    return response;
}

export const getPatientCervicalAssessment3 = async (payload: any) => {
    let url = `${apiVptsBaseUrl}${TherapistGetPatientCervicalAssessment3}`;
    url = queryParamsToUrl(url, payload);
    const response = await axiosApiCall.get(url);
    return response;
}

export const getPatientLowerAssessment3 = async (payload: any) => {
    let url = `${apiVptsBaseUrl}${TherapistGetPatientLowerAssessment3}`;
    url = queryParamsToUrl(url, payload);
    const response = await axiosApiCall.get(url);
    return response;
}

export const getMedicalHistories = async (payload: any) => {
    let url = `${apiVptsBaseUrl}${PatientGetMedicalHistories}`;
    url = queryParamsToUrl(url, payload);
    const response = await axiosApiCall.get(url);
    return response;
}

export const patientMedicalHistory = async (payload: any) => {
    let url = `${apiVptsBaseUrl}${PatientGetPatientMedicalHistory}`;
    url = queryParamsToUrl(url, payload);
    const response = await axiosApiCall.get(url);
    return response;
}

export const getPatientLumbarAssessment2 = async (payload: any) => {
    let url = `${apiVptsBaseUrl}${TherapistGetPatientLumbarAssessment2}`;
    url = queryParamsToUrl(url, payload);
    const response = await axiosApiCall.get(url);
    return response;
}

export const getPatientLumbarAssessment3 = async (payload: any) => {
    let url = `${apiVptsBaseUrl}${TherapistGetPatientLumbarAssessment3}`;
    url = queryParamsToUrl(url, payload);
    const response = await axiosApiCall.get(url);
    return response;
}

export const adminManageFile = async (payload: any) => {
    const response = await axiosApiCall.post(`${apiVptsBaseUrl}${AdminManageFile}`, payload);
    return response;
}

export const adminManagePatientNew = async (payload: any) => {
    const response = await axiosApiCall.post(`${apiVptsBaseUrl}${AdminManagePatientNew}`, payload);
    return response;
}

export const adminGetAppoinmentsStatus = async (payload: any) => {
    let url = `${apiVptsBaseUrl}${AdminGetAppoinmentsStatus}`;
    url = queryParamsToUrl(url, payload);
    const response = await axiosApiCall.get(url);
    return response;
}
export const adminGetQualityAnalysisReport = async (payload: any) => {
    let url = `${apiVptsBaseUrl}${AdminGetQualityAnalysisReport}`;
    url = queryParamsToUrl(url, payload);
    const response = await axiosApiCall.get(url);
    return response;
}
export const adminGetCAPrisonReport = async (payload: any) => {
    let url = `${apiVptsBaseUrl}${AdminGetCAPrisonReport}`;
    url = queryParamsToUrl(url, payload);
    const response = await axiosApiCall.get(url);
    return response;
}

export const adminGetDmeSurgicalAppoinments = async (payload: any) => {
    let url = `${apiVptsBaseUrl}${AdminGetDmeSurgicalAppoinments}`;
    url = queryParamsToUrl(url, payload);
    const response = await axiosApiCall.get(url);
    return response;
}

export const adminGetUserDetails = async (payload: any) => {
    let url = `${apiVptsBaseUrl}${AdminGetUserDetails}`;
    url = queryParamsToUrl(url, payload);
    const response = await axiosApiCall.get(url);
    return response;
}

export const adminGetAllTherapists = async (payload: any) => {
    let url = `${apiVptsBaseUrl}${AdminGetAllTherapists}`;
    url = queryParamsToUrl(url, payload);
    const response = await axiosApiCall.get(url);
    return response;
}

export const adminGetCompanies = async (payload: any) => {
    let url = `${apiVptsBaseUrl}${AdminGetCompanies}`;
    url = queryParamsToUrl(url, payload);
    const response = await axiosApiCall.get(url);
    return response;
}

export const adminGetPrisonSites = async (payload: any) => {
    let url = `${apiVptsBaseUrl}${AdminGetPrisonSites}`;
    url = queryParamsToUrl(url, payload);
    const response = await axiosApiCall.get(url);
    return response;
}

export const adminGetPrisonDiagnosisCodes = async (payload: any) => {
    let url = `${apiVptsBaseUrl}${AdminGetPrisonDiagnosisCodes}`;
    url = queryParamsToUrl(url, payload);
    const response = await axiosApiCall.get(url);
    return response;
}

export const adminSearchPatient = async (payload: any) => {
    let url = `${apiVptsBaseUrl}${AdminSearchPatient}`;
    url = queryParamsToUrl(url, payload);
    const response = await axiosApiCall.get(url);
    return response;
}

export const adminSaveInboxMessage = async (payload: any) => {
    const response = await axiosApiCall.post(`${apiVptsBaseUrl}${AdminSaveInboxMessage}`, payload);
    return response;
}

export const GetAssesmentPdf = async (payload: any) => {
    let url = `${apiVptsBaseUrl}${GetAssesmentPdfApi}`;
    url = queryParamsToUrl(url, payload);
    const response = await axiosApiCall.get(url,{responseType: 'blob'});
    return response;
}

export const getPatientLowerAssessment2 = async (payload: any) => {
    let url = `${apiVptsBaseUrl}${TherapistGetPatientLowerAssessment2}`;
    url = queryParamsToUrl(url, payload);
    const response = await axiosApiCall.get(url);
    return response;
}

export const getPatientThoracicAssessment2 = async (payload: any) => {
    let url = `${apiVptsBaseUrl}${TherapistGetPatientThoracicAssessment2}`;
    url = queryParamsToUrl(url, payload);
    const response = await axiosApiCall.get(url);
    return response;
}

export const getPatientThoracicAssessment3 = async (payload: any) => {
    let url = `${apiVptsBaseUrl}${TherapistGetPatientThoracicAssessment3}`;
    url = queryParamsToUrl(url, payload);
    const response = await axiosApiCall.get(url);
    return response;
}

export const getPatientUpperAssessment2 = async (payload: any) => {
    let url = `${apiVptsBaseUrl}${TherapistGetPatientUpperAssessment2}`;
    url = queryParamsToUrl(url, payload);
    const response = await axiosApiCall.get(url);
    return response;
}
export const getPatientUpperAssessment3 = async (payload: any) => {
    let url = `${apiVptsBaseUrl}${TherapistGetPatientUpperAssessment3}`;
    url = queryParamsToUrl(url, payload);
    const response = await axiosApiCall.get(url);
    return response;
}
export const getPatientVestibularAssessment2 = async (payload: any) => {
    let url = `${apiVptsBaseUrl}${TherapistGetPatientVestibularAssessment2}`;
    url = queryParamsToUrl(url, payload);
    const response = await axiosApiCall.get(url);
    return response;
}
export const getPatientVestibularAssessment3 = async (payload: any) => {
    let url = `${apiVptsBaseUrl}${TherapistGetPatientVestibularAssessment3}`;
    url = queryParamsToUrl(url, payload);
    const response = await axiosApiCall.get(url);
    return response;
}
export const getPatientReAssessment = async (payload: any) => {
    let url = `${apiVptsBaseUrl}${TherapistGetPatientReAssessment}`;
    url = queryParamsToUrl(url, payload);
    const response = await axiosApiCall.get(url);
    return response;
}
export const getPatientReAssessment2 = async (payload: any) => {
    let url = `${apiVptsBaseUrl}${TherapistGetPatientReAssessment2}`;
    url = queryParamsToUrl(url, payload);
    const response = await axiosApiCall.get(url);
    return response;
}
export const getPatientGetAppoinments = async (payload: any) => {
    let url = `${apiVptsBaseUrl}${PatientGetAppoinments}`;
    url = queryParamsToUrl(url, payload);
    const response = await axiosApiCall.get(url);
    return response;
}
export const getSharedVideos = async (payload: any) => {
    let url = `${apiVptsBaseUrl}${TherapistGetSharedVideos}`;
    url = queryParamsToUrl(url, payload);
    const response = await axiosApiCall.get(url);
    return response;
}

export const savePatientMedicalHistory = async (payload: any) => {
    const response = await axiosApiCall.post(`${apiVptsBaseUrl}${PatientSavePatientMedicalHistory}`, payload);
    return response;
}

export const patientAssessmentZoomDetailWeb = async (payload: any) => {
    let url = `${apiVptsBaseUrl}${PatientGetPatientAssessmentZoomDetailWeb}`;
    url = queryParamsToUrl(url, payload);
    const response = await axiosApiCall.get(url);
    return response;
}

export const getPatientTherapists = async (payload: any) => {
    let url = `${apiVptsBaseUrl}${PatientGetTherapists}`;
    url = queryParamsToUrl(url, payload);
    const response = await axiosApiCall.get(url);
    return response;
}
export const getCompanies = async (payload: any) => {
    let url = `${apiVptsBaseUrl}${GetCompanies}`;
    url = queryParamsToUrl(url, payload);
    const response = await axiosApiCall.get(url);
    return response;
}
export const getCompaniesforPatient = async (payload: any) => {
    let url = `${apiVptsBaseUrl}${PatientGetCompaniesforPatient}`;
    url = queryParamsToUrl(url, payload);
    const response = await axiosApiCall.get(url);
    return response;
}

export const patientSaveAppoinmentNew = async (payload: any) => {
    const response = await axiosApiCall.post(`${apiVptsBaseUrl}${PatientSaveAppoinmentNew}`, payload);
    return response;
}

export const patientRequestForAppoinment = async (payload: any) => {
    const response = await axiosApiCall.post(`${apiVptsBaseUrl}${PatientRequestForAppoinment}`, payload);
    return response;
}
export const adminRegisterNurse = async (payload: any) => {
    const response = await axiosApiCall.post(`${apiVptsBaseUrl}${AdminRegisterNurse}`, payload);
    return response;
}

export const adminEnableDisableUser = async (payload: any) => {
    const response = await axiosApiCall.post(`${apiVptsBaseUrl}${AdminEnableDisableUser}`, payload);
    return response;
}

export const adminOverrideUserNPI = async (payload: any) => {
    const response = await axiosApiCall.post(`${apiVptsBaseUrl}${AdminOverrideUserNPI}`, payload);
    return response;
}

export const adminUploadPhoto = async (payload: any) => {
    const settings = {
        method: "POST",
        body: payload,
        credentials: "include" as RequestCredentials,
        headers: {
            'Accept': 'application/json, text/plain, */*',
            'ContentType': 'multipart/form-data',
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Headers": "*",
        }
    }
    return fetch(`${apiVptsBaseUrl}${AdminUpload}`, settings)
        .then((response) => {
            return response.json()
        })
        .then(responseJson => {
            return responseJson;
        })
}

export const getAdminGetDashBoardData = async (payload: any) => {
    let url = `${apiVptsBaseUrl}${AdminGetDashBoardData}`;
    url = queryParamsToUrl(url, payload);
    const response = await axiosApiCall.get(url);
    return response;
}

export const getAdminGetMyPatient = async (payload: any) => {
    let url = `${apiVptsBaseUrl}${AdminGetMyPatient}`;
    url = queryParamsToUrl(url, payload);
    const response = await axiosApiCall.get(url);
    return response;
}

export const getAdminGetMyPayments = async (payload: any) => {
    let url = `${apiVptsBaseUrl}${AdminGetMyPayments}`;
    url = queryParamsToUrl(url, payload);
    const response = await axiosApiCall.get(url);
    return response;
}

export const getAdminGetMarketingData = async (payload: any) => {
    let url = `${apiVptsBaseUrl}${AdminGetMarketingData}`;
    url = queryParamsToUrl(url, payload);
    const response = await axiosApiCall.get(url);
    return response;
}

export const adminAppRejUser = async (payload: any) => {
    const response = await axiosApiCall.post(`${apiVptsBaseUrl}${AdminAppRejUser}`, payload);
    return response;
}

export const getAdminGetAppointments = async (payload: any) => {
    let url = `${apiVptsBaseUrl}${AdminGetAppointments}`;
    url = queryParamsToUrl(url, payload);
    const response = await axiosApiCall.get(url);
    return response;
}

export const getAdminGetAppointmentPays = async (payload: any) => {
    let url = `${apiVptsBaseUrl}${AdminGetAppointmentPays}`;
    url = queryParamsToUrl(url, payload);
    const response = await axiosApiCall.get(url);
    return response;
}

export const getAdminGetAccountReceived = async (payload: any) => {
    let url = `${apiVptsBaseUrl}${AdminGetAccountReceived}`;
    url = queryParamsToUrl(url, payload);
    const response = await axiosApiCall.get(url);
    return response;
}

export const getAdminGetDischargeReport = async (payload: any) => {
    let url = `${apiVptsBaseUrl}${AdminGetDischargeReport}`;
    url = queryParamsToUrl(url, payload);
    const response = await axiosApiCall.get(url);
    return response;
}

export const getAdminGetFirstAppoinments = async (payload: any) => {
    let url = `${apiVptsBaseUrl}${AdminGetFirstAppoinments}`;
    url = queryParamsToUrl(url, payload);
    const response = await axiosApiCall.get(url);
    return response;
}

export const getAdminGetRequestsForAppointment = async (payload: any) => {
    let url = `${apiVptsBaseUrl}${AdminGetRequestsForAppointment}`;
    url = queryParamsToUrl(url, payload);
    const response = await axiosApiCall.get(url);
    return response;
}

export const getAdminGetPatientDischarge = async (payload: any) => {
    let url = `${apiVptsBaseUrl}${AdminGetPatientDischarge}`;
    url = queryParamsToUrl(url, payload);
    const response = await axiosApiCall.get(url);
    return response;
}

export const getAdminDownloadPatientDischarge = async (payload: any) => {
    let url = `${apiVptsBaseUrl}${AdminDownloadPatientDischarge}`;
    url = queryParamsToUrl(url, payload);
    const response = await axiosApiCall.get(url);
    return response;
}

export const getAdminDownloadPatientRefusal = async (payload: any) => {
    let url = `${apiVptsBaseUrl}${AdminDownloadPatientRefusal}`;
    url = queryParamsToUrl(url, payload);
    const response = await axiosApiCall.get(url);
    return response;
}

export const getAdminGetPatientRefusal = async (payload: any) => {
    let url = `${apiVptsBaseUrl}${AdminGetPatientRefusal}`;
    url = queryParamsToUrl(url, payload);
    const response = await axiosApiCall.get(url);
    return response;
}

export const adminUpdateAppointmentPay = async (payload: any) => {
    const response = await axiosApiCall.post(`${apiVptsBaseUrl}${AdminUpdateAppointmentPay}`, payload);
    return response;
}

export const adminGetUpdateUserFees = async (payload: any) => {
    const response = await axiosApiCall.post(`${apiVptsBaseUrl}${AdminGetUpdateUserFees}`, payload);
    return response;
}

export const adminUpdateRequestStatus = async (payload: any) => {
    const response = await axiosApiCall.post(`${apiVptsBaseUrl}${AdminUpdateRequestStatus}`, payload);
    return response;
}

export const adminUpdateAccountReceivable = async (payload: any) => {
    const response = await axiosApiCall.post(`${apiVptsBaseUrl}${AdminUpdateAccountReceivable}`, payload);
    return response;
}

export const getAdminGetAccountReceivable = async (payload: any) => {
    let url = `${apiVptsBaseUrl}${AdminGetAccountReceivable}`;
    url = queryParamsToUrl(url, payload);
    const response = await axiosApiCall.get(url);
    return response;
}

export const adminGenerateInvoice = async (payload: any) => {
    let url = `${apiVptsBaseUrl}${AdminGenerateInvoice}`;
    url = queryParamsToUrl(url, payload);
    const response = await axiosApiCall.get(url);
    return response;
}

export const adminGetTherapistAppoinments = async (payload: any) => {
    let url = `${apiVptsBaseUrl}${AdminGetTherapistAppoinments}`;
    url = queryParamsToUrl(url, payload);
    const response = await axiosApiCall.get(url);
    return response;
}

export const adminGetAllTherapist = async (payload: any) => {
    const settings = {
        method: "GET",
        body: payload,
        headers: {
            'responseType': 'blob',
        }
    }
    let url = `${apiVptsBaseUrl}${AdminGetAllTherapist}`;
    url = queryParamsToUrl(url, payload);
    const response = await axiosApiCall.get(url, settings);
    return response;
}

export const adminGetSelfPayAppointments = async (payload: any) => {
    let url = `${apiVptsBaseUrl}${AdminGetSelfPayAppointments}`;
    url = queryParamsToUrl(url, payload);
    const response = await axiosApiCall.get(url);
    return response;
}

export const stripeCheckoutCreateIntent = async (payload: any) => {
    let url = `${apiVptsBaseUrl}${StripeCheckoutCreateIntent}`;
    url = queryParamsToUrl(url, payload);
    const response = await axiosApiCall.get(url);
    return response;
}

export const stripeCheckoutBookSelfPayAppointment = async (payload: any) => {
    const response = await axiosApiCall.post(`${apiVptsBaseUrl}${StripeCheckoutBookSelfPayAppointment}`, payload);
    return response;
}

export const adminUpdateTherapistFees = async (payload: any) => {
    const response = await axiosApiCall.post(`${apiVptsBaseUrl}${AdminUpdateTherapistFees}`, payload);
    return response;
}

export const setPasswordApi = async (payload: any) => {
    const response = await axiosApiCall.post(`${apiVptsBaseUrl}${SetPassword}`, payload);
    return response;
}

export const updateRstPasswordink = async (payload: any) => {
    const response = await axiosApiCall.post(`${apiVptsBaseUrl}${UpdateRstPasswordink}`, payload);
    return response;
}

export const adminSubmitClaimForm = async (payload: any) => {
    const response = await axiosApiCall.post(`${apiVptsBaseUrl}${AdminSubmitClaimForm}`, payload);
    return response;
}